import React from 'react';
import { Snackbar, Alert } from '@mui/material';

const CustomSnackbar = ({
  open, 
  message, 
  onClose, 
  severity = "success", 
  autoHideDuration = 3000, 
  anchorOrigin = { vertical: "bottom", horizontal: "center" }, 
  sx = { width: '100%' },
  ...props 
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      {...props}
    >
      <Alert onClose={onClose} severity={severity} sx={sx} {...props}>
        {message}
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
